import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取列表
export const getCarportTypeList = params => {
    return get("/admin/carportAttribute/page", params);
};
// 新增
export const addCarportType = params => {
    return post("/admin/carportAttribute/add", params);
};
// 修改
export const editCarportType = params => {
    return put(`/admin/carportAttribute/${params.id}`, params);
};



// WEBPACK FOOTER //
// ./src/api/carportType.js